import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { profileScrollData, profileScrollSubTitle } from "../../../../Data/BonusUiData/ScrollbarData";
import { Image, LI, UL } from "../../../../AbstractElements";
import { ProfileScrollableTitle } from "../../../../Utils/Constants";
import { dynamicImage } from "../../../../Utils";
import ScrollBar from "react-perfect-scrollbar";

export default function ProfileScrollable() {
  return (
    <Col xxl={4} md={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={ProfileScrollableTitle} subTitle={profileScrollSubTitle} />
        <CardBody>
          <ScrollBar className="vertical-scroll scroll-demo scroll-b-none custom-container">
            <UL>
              {profileScrollData &&
                profileScrollData.map((item, index) => (
                  <LI className="list-group-item-action list-hover-primary" key={index}>
                    <Image className="rounded-circle" src={dynamicImage(`user/${item.image}`)} alt="user" />
                    {item.text}
                  </LI>
                ))}
            </UL>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
}
